import React, { useState } from "react";
import DurationControl from "react-duration-control";
import "react-duration-control/dist/react-duration-control.css";
import "../../../../StyleSheet/MainComponent/DurationField.scss"
export const DurationField = ({setdurationkey , duration_key}) => {
  const [millis, setMillis] = useState(0);

  const handleChange = (value) => {
    setMillis(value);

    const totalSeconds = Math.floor(value / 1000);
    const days = Math.floor(totalSeconds / (24 * 3600));
    const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const formatted = `${days} ${String(hours).padStart(2, "0")}:${String(
      minutes
    ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    console.log("Formatted Duration →", formatted);
    setdurationkey(formatted)
  };

  return (
    <div style={{ width: "100%", maxWidth: "500px" }}>
   
      <DurationControl
        pattern="Days {dd} Hours {hh} Minutes {mm} "
        value={millis}
        onChange={handleChange}
      />
    </div>
  );
};
